// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"180ff5f2","229":"7a0ec3d4","242":"37e60052","388":"0773b4ec","628":"a2a4325c"}[chunkId] + ".chunk.js";
};